module.exports = {"320204001":"黄巷街道","320204002":"山北街道","320204003":"北大街街道","320204004":"惠山街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320204.json
// module id = 840
// module chunks = 0